<template lang="pug">
  b-dropdown(
    :text="timezone",
    size="sm",
    variant="light text-left",
    @show="showMenu")
    b-dropdown-header.search-header
      input(
        ref="searchInput"
        type="text",
        v-model="text",
        :placeholder="$t('search_location')")
    b-dropdown-item-button(
      v-for="tz in results",
      :key="tz",
      @click="select(tz)") {{tz}}
</template>

<script>
import _ from 'lodash'
import moment from 'moment-timezone'
const timezones = moment.tz.names()

export default {
  name: 'tz-select',
  methods: {
    select (tz) {
      const tzo = moment.tz.zone(tz)
      const now = Date.now()
      this.timezone = tzo.name
      let data = {
        name: tzo.name,
        abbr: tzo.abbr(now),
        offset: tzo.utcOffset(now)
      }
      this.$emit('changed', data)
    },
    showMenu () {
      this.$nextTick(() => {
        this.$refs.searchInput.focus()
      })
    }
  },
  computed: {
    results () {
      if (!this.text) return []
      let res = _.filter(timezones, v => {
        return _.includes(v.toLowerCase(), this.text.toLowerCase())
      })
      res = _.slice(res, 0, 10)
      return res
    }
  },
  mounted () {
    this.timezone = moment.tz.guess()
  },
  data () {
    return {
      timezone: '',
      text: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.search-header {
  padding: 0 10px !important;
  > input[type="text"] {
    width: 100%;
    border: 0;
    line-height: 26px;
    border-bottom: 1px solid #949494;
    outline: none;
  }
}
</style>
